import { assetSrc } from '../../media/media-asset.util'
import { gameCollectionHeadingBgMap, getTemplate } from '../../media/template-loader'

type Props = {
  headingContent?: string
  headingTextColor?: string
  headingBgImageTemplate?: string
  headingBgImageUrl?: string
}

export function GameCollectionHeader(props: Props) {
  const { headingContent, headingTextColor = '#FFFFFF', headingBgImageTemplate = 'gameCollectionHeadingBgDefault01', headingBgImageUrl } = props

  const template = getTemplate(gameCollectionHeadingBgMap, headingBgImageTemplate)
  const imgSrc = headingBgImageUrl ?? assetSrc(template)

  return (
    <div className="relative h-[120px] w-full overflow-hidden">
      <img src={imgSrc} alt="" className="absolute left-1/2 top-0 h-full w-auto max-w-none -translate-x-1/2 object-contain" />
      <p
        className="absolute top-1/3 w-full -translate-y-1/3 text-center text-[30px]/[36px] font-bold"
        style={{
          textShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
          color: headingTextColor,
        }}
      >
        {headingContent}
      </p>
    </div>
  )
}
